import { createActionGroup } from '@ngrx/store';
import { AliasAddRecordResponse } from './alias-base.model';
import { zefActionFailPayload, zefActionPayload, zefActionSuccessPayload } from '@vshosting/core';

export const AliasBaseActions = createActionGroup({
  source: '@vshapps/cdn/core/alias-base',
  events: {
    'alias add record': zefActionPayload<string>(),
    'alias add record success': zefActionSuccessPayload<AliasAddRecordResponse>(),
    'alias add record fail': zefActionFailPayload,
  }
});
